// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_@module-federation+runtime-tools@2.9.2__webpack@5.111.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_@module-federation+runtime-tools@2.9.2__webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout.app-root {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
}

.app-main-content {
    padding: @app-main-content-padding;
    background: white;
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/app.less"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;AACrB","sourcesContent":[".ant-layout.app-root {\n    display: flex;\n    min-height: 100vh;\n    flex-direction: column;\n}\n\n.app-main-content {\n    padding: @app-main-content-padding;\n    background: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
